export default "__VITE_ASSET__BL7o07XK__"